import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import {
  DashboardShell,
  createShellNavLink,
  type ShellNavItem,
} from '@vipso/shared';
import {
  IconLayoutDashboard,
  IconBuilding,
  IconBuildingCommunity,
  IconUsers,
  IconClipboardList,
  IconAdjustments,
  IconShield,
  IconChecklist,
  IconCurrencyRupee,
} from '@tabler/icons-react';
import { useAdminAuth } from '../hooks/useAdminAuth';

const navItems: ShellNavItem[] = [
  { to: '/', label: 'Dashboard', icon: IconLayoutDashboard, end: true },
  { to: '/orgs', label: 'Organizations', icon: IconBuilding },
  { to: '/tenants', label: 'Tenants', icon: IconBuildingCommunity },
  { to: '/roles', label: 'Roles', icon: IconShield },
  { to: '/staff', label: 'Staff', icon: IconUsers },
  { to: '/tasks', label: 'Tasks', icon: IconChecklist },
  { to: '/audit', label: 'Audit Log', icon: IconClipboardList },
  { to: '/features', label: 'Features', icon: IconAdjustments },
  { to: '/billing', label: 'Billing', icon: IconCurrencyRupee },
];

const ShellNavLink = createShellNavLink(NavLink);

export function AdminShell() {
  const { admin, logout } = useAdminAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <DashboardShell
      LinkComponent={ShellNavLink}
      navItems={navItems}
      brandTitle="VIPSo"
      orgName="System"
      user={admin ? { name: admin.name, email: admin.email } : null}
      profileLinks={[
        {
          label: 'Account settings',
          onClick: () => navigate('/account'),
        },
        {
          label: 'Features',
          onClick: () => navigate('/features'),
        },
      ]}
      onLogout={handleLogout}
    >
      <Outlet />
    </DashboardShell>
  );
}
